/**
 * region for libraries*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

/**
 * region for styles*/
import { attributesListKeywordStyle } from './style/attributesListKeywordStyle';

/**
 * region for components*/
import ListChipAttributes from './ListChipAttributes';

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from '../../constants/Constants';

class AttributesListKeyword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attributes: []
        };
    }

    load() {
        let self = this;
        let requestData = {
            idkeyword: self.props.keyword.IDKEYWORD
        };
        ajax.get(Constants.ROUTE_API_CONTENT_ATTRIBUTES_BY_KEYWORD,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({ attributes: response.data });
                }
            });
    }
    componentDidMount() {
        this.load();
    }

    render() {
        let self = this;
        return (
            <ListChipAttributes
                keyword={self.props.keyword}
                items={self.state.attributes} />
        );
    }
}
AttributesListKeyword.propTypes = {
    classes: PropTypes.object.isRequired
};
export default withStyles(attributesListKeywordStyle)(AttributesListKeyword);





